import { render, staticRenderFns } from "./memberLayout.vue?vue&type=template&id=795dd3bf&scoped=true"
import script from "./memberLayout.vue?vue&type=script&lang=js"
export * from "./memberLayout.vue?vue&type=script&lang=js"
import style0 from "./memberLayout.vue?vue&type=style&index=0&id=795dd3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795dd3bf",
  null
  
)

export default component.exports